import { WheelEvent } from 'react';

/**
 * Prevents the mouse wheel from changing the value of a `<input type="number">`.
 * React's `onWheel` is passive, so `preventDefault()` has no effect here — we
 * blur the input instead, which stops the value change. Attach to a number
 * input via `onWheel={preventNumberInputScroll}`.
 */
export const preventNumberInputScroll = (event: WheelEvent<HTMLElement>): void => {
  (event.target as HTMLElement).blur();
};

export default preventNumberInputScroll;
